var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 75,
    viewBox: "0 0 83 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2907 29.3416V66.1733C82.2907 70.665 78.6157 74.34 74.124 74.34H8.79069C4.29902 74.34 0.624023 70.665 0.624023 66.1733L0.664857 17.1733C0.664857 12.6816 4.29902 9.00663 8.79069 9.00663H50.0324C49.7874 10.3133 49.624 11.7016 49.624 13.09C49.624 14.4783 49.7874 15.8666 50.0324 17.1733H8.79069L41.4574 37.59L56.4432 28.2391C58.3624 29.995 60.6082 31.3425 63.099 32.2408L41.4574 45.7566L8.79069 25.34V66.1733H74.124V33.0983C77.1457 32.4858 79.9224 31.1383 82.2907 29.3416ZM57.7907 13.09C57.7907 19.8683 63.2624 25.34 70.0407 25.34C76.819 25.34 82.2907 19.8683 82.2907 13.09C82.2907 6.31163 76.819 0.839966 70.0407 0.839966C63.2624 0.839966 57.7907 6.31163 57.7907 13.09Z",
    fill: "#1F1919",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.936 26.872C77.0804 26.872 82.872 21.0804 82.872 13.936C82.872 6.79164 77.0804 1 69.936 1C62.7916 1 57 6.79164 57 13.936C57 21.0804 62.7916 26.872 69.936 26.872Z",
    fill: "#EB333C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 75,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.0fb3a4e91b03eee6542d9e5c8d89d8fd.svg";
export { ForwardRef as ReactComponent };